import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const TextModal: React.FC<{
  header?: string;
  text: string | string[];
  open: boolean;
  toggle: () => void;
}> = ({ header, text, open, toggle }) => {
  let content: JSX.Element | null = null

  if (Array.isArray(text)) {
    content =
      <ul>
        {text.map((t, i) => (
          <li key={i}>{t}</li>
        ))}
      </ul>
  } else {
    content = <p>{text}</p>
  }
  return (
    <>
      <Modal
        isOpen={open}
        classNames={{
          modal: 'modal-container'
        }}
        toggle={toggle}
        size="lg"
      >
        <ModalHeader>
          {header || 'Text'}
        </ModalHeader>
        <ModalBody>
          {content}
        </ModalBody>
      </Modal>
    </>
  )
}

export default TextModal
